
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    dataSvg: require('~/assets/svg/Data Arranging_Two Color.svg?raw')
  }),
  computed: {
    ...mapState(['env']),
    ...mapState('session', ['user', 'initialized']),
    ...mapGetters(['canContrib']),
    ...mapGetters('session', ['activeAccount'])
  },
  created () {
    this.fetchVocabulary()
    if (this.activeAccount) {
      this.fetchPublicationSites(this.activeAccount)
    }
  },
  methods: {
    ...mapActions('session', ['login']),
    ...mapActions(['fetchVocabulary', 'fetchPublicationSites'])
  }
}
